import { useEffect } from 'react';
import { Bike } from 'lucide-react';

interface SplashScreenProps {
  onComplete: () => void;
  onShowMapShowcase?: () => void;
  onShowAnimationsShowcase?: () => void;
  onShowNotificationsShowcase?: () => void;
}

export function SplashScreen({ onComplete, onShowMapShowcase, onShowAnimationsShowcase, onShowNotificationsShowcase }: SplashScreenProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 2000);
    
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="absolute inset-0 bg-[#E0001B] flex items-center justify-center animate-fadeIn">
      <div className="text-center">
        <div className="mb-8 animate-pulse">
          <div className="w-24 h-24 mx-auto rounded-full bg-white/20 flex items-center justify-center mb-4">
            <Bike className="w-16 h-16 text-white" />
          </div>
          <h1 className="text-white text-[42px]">GO7</h1>
          <p className="text-white/80 text-[18px]">Rider</p>
        </div>
        
        {/* Spinner */}
        <div className="flex justify-center">
          <div className="w-8 h-8 border-3 border-white/30 border-t-white rounded-full animate-spin" />
        </div>
      </div>

    </div>
  );
}